import React from 'react';
import { Router, Route, Link, hashHistory } from 'react-router';

import Header from '../components/header.jsx';
import TextField from 'material-ui/TextField';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

const QuestionPage = React.createClass({
	getInitialState: function() {
		return {
			response: ''
		}
	},
	componentWillReceiveProps: function() {
		if (document.querySelector('.selected')) {
			document.querySelector('.selected').classList.remove('selected');
		}
		this.setState({
			response: ''
		});
	},
	_getChoices: function() {
		return this.props.choices.map((choice, i) => {
			return (
				<div
					className="choice"
					key={i}
					onClick={this._selectChoice}
				>{choice}</div>
			)
		});
	},
	_submitResponse: function() {
		this.props.addResponse(this.state.response);
	},
	_updateResponse: function(e) {
		this.setState({
			response: e.target.value.trim()
		});
	},
	_selectChoice: function(e) {
		if (document.querySelector('.selected')) {
			document.querySelector('.selected').classList.remove('selected');
		}
		e.target.classList.add('selected');
		this.setState({
			response: e.target.innerHTML
		})
	},
	render: function() {
		const style = {
			progressBar: {
				width: '76%',
				height: '14px',
				backgroundColor: '#eee',
				margin: '3em auto',
			},
			response: {
				display: 'block',
				textAlign: 'center',
				width: '76%',
				margin: '0 auto',
			},
			button: {
				position: 'absolute',
				bottom: '0px',
				width: '100%',
				height: '50px',
				backgroundColor: '#82CCC8',
			},
			label: {
				fontSize: '18px',
				color: '#fff'
			}
		};

		if (this.props.type == 'radio') {
			const choices = this._getChoices();
			return (
				<div>
					<LinearProgress
						mode="determinate"
						value={this.props.progress}
						style={style.progressBar}
						color="#427AA1"
					/>
					<p className="body">{this.props.question}</p>
					<div className="choices">
						{choices}
					</div>
					<FlatButton
						label={this.props.buttonLabel}
						onClick={this._submitResponse}
						style={style.button}
						labelStyle={style.label}
					/>
				</div>
			)
		} else {
			return (
				<div>
					<LinearProgress
						mode="determinate"
						value={this.props.progress}
						style={style.progressBar}
						color='#427AA1'
					/>
					<p className="body">{this.props.question}</p>
					<TextField hintText="Answer" style={style.response} onChange={this._updateResponse} />
					<FlatButton
						label={this.props.buttonLabel}
						onClick={this._submitResponse}
						style={style.button}
						labelStyle={style.label}
					/>
				</div>
			)
		}
	}
});

export default QuestionPage;


// WEBPACK FOOTER //
// ./src/views/question-page.jsx